import React from 'react';
import moment from 'moment';
import { CURRENCY_SYMBOLS } from '../../../../utils/constants/currency-symbols';
import Modal from '../../../../shared/modal';
import Error from '../../../../shared/error';
import Table from '../../../../shared/table';
import Button from '../../../../shared/button';


interface IConfirmPurchaseCreate {
    openModal: boolean;
    items?: Array<any>;
    edit: boolean;
    detailsInfo?: any;
    generalError?: string;
    accessControl?: any;
    pageActions?: any;
    submitLoading?: boolean;
    currency?: string
    handleCloseModal: () => void;
    onApproveAction: (submit?: boolean) => void;
}

const ConfirmPurchaseCreate = ({
    openModal,
    items,
    edit,
    detailsInfo,
    generalError,
    submitLoading,
    accessControl,
    pageActions,
    currency,
    handleCloseModal,
    onApproveAction,
}: IConfirmPurchaseCreate) => {

    const onCloseModal = () => {
        handleCloseModal();
    }

    let findTotalQuantity = 0;
    let subPriceTotal = 0;

    items && items?.length > 0 &&
        [...items].map((currentValue: any) => {
            subPriceTotal = subPriceTotal + Number(currentValue.price || 0) * Number(currentValue?.qty || 0);
            findTotalQuantity = Number(findTotalQuantity) + Number(currentValue?.qty || 0);
            return currentValue;
        });


    return (
        <Modal
            open={openModal}
            showInRight
            onClose={() => onCloseModal()}
            title='Submit Purchase Order'
            contentContainerStyle='!min-w-[70vw]'>
            <div className={'p-2 min-w-[65vw] min-h-[300px]'}>
                <div className='border-b-2 border-slate-200 pb-2 my-1'>
                    <p className='font-medium text-slate-700'>Purchases &gt; {edit ? 'Edit' : 'Create'} Order</p>
                </div>
                {generalError && <Error text={generalError} />}
                <div className='bg-[#f8f9fc] rounded-[6px] p-3'>
                    <p className='text-[20px]'>Review Details</p>
                    <div className='grid grid-cols-3 span-2 my-3 border-b border-[#e4e4e4] pb-2'>
                        {detailsInfo?.supplier &&
                            <div className='mb-2'>
                                <span>Supplier: </span>
                                <span className='font-bold'>{detailsInfo?.supplier?.name || detailsInfo?.supplier?.username}</span>
                            </div>
                        }
                        {detailsInfo?.supplier?.email &&
                            <div className='mb-2'>
                                <span>Supplier Email: </span>
                                <span className='font-bold'>{detailsInfo?.supplier?.email}</span>
                            </div>
                        }
                        {detailsInfo?.expectedDeliveryDate &&
                            <div className='mb-2'>
                                <span>Expected Delivery: </span>
                                <span className='font-bold'>{moment(detailsInfo?.expectedDeliveryDate).format('DD MMMM YYYY')}</span>
                            </div>
                        }
                    </div>
                    <div className=' border-b border-[#e4e4e4] pb-2 my-2'>
                        <Table
                            columns={['Item Name', 'Price per Unit', 'Units', 'Subtotal']}
                            hidePagination={true}
                            headStyle='!bg-[#000000] !text-white'>
                            {items && items?.length > 0 && items?.map((row: any, idx: number) => {
                                return (
                                    <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                        <td className='px-6 py-4'>{row?.itemName}</td>
                                        <td className='px-6 py-4'>{CURRENCY_SYMBOLS[`${(currency || '')}`]}{Number(row?.price || 0).toFixed(2)}</td>
                                        <td className='px-6 py-4'>{row?.qty || ''} unit(s)</td>
                                        <td className='px-6 py-4'>
                                            {CURRENCY_SYMBOLS[`${(currency || '')}`]}{(Number(row?.price || 0) * Number(row?.qty || 0)).toFixed(2)}
                                        </td>
                                    </tr>
                                )
                            })}
                            {items && items?.length > 0 &&
                                <tr className='!font-bold !text-black !border-t-2 border-[#f7a21e]'>
                                    <td></td>
                                    <td className='px-6 py-4'>Total:</td>
                                    <td className='px-6 py-4'>{findTotalQuantity} unit(s)</td>
                                    <td className='px-6 py-4'>
                                        {CURRENCY_SYMBOLS[`${(currency || '')}`]}{Number(subPriceTotal || 0).toFixed(2)}
                                    </td>
                                </tr>
                            }
                        </Table>
                        <div className='mt-2 grid grid-cols-2 span-2 min-w-[100%]'>
                            <div >
                                <div className='border border-[#a4a4a4] flex flex-row justify-between items-center p-2'>
                                    <p className='text-[20px]'>Total Items</p>
                                    <p className='text-[20px] text-primary-default'>{findTotalQuantity} Units</p>
                                </div>
                                <div className='border border-[#a4a4a4] flex flex-row justify-between items-center p-2'>
                                    <p className='text-[20px]'>Shipping Costs</p>
                                    <p className='text-[20px] text-primary-default'>{CURRENCY_SYMBOLS[`${(currency || '')}`]}{Number(detailsInfo?.shippingCosts || 0).toFixed(2)}</p>
                                </div>
                                <div className='border border-[#a4a4a4] flex flex-row justify-between items-center p-2'>
                                    <p className='text-[20px]'>Total Amount</p>
                                    <p className='text-[20px] text-primary-default'>
                                        {CURRENCY_SYMBOLS[`${(currency || '')}`]}{(Number(subPriceTotal || 0) + Number(detailsInfo?.shippingCosts || 0)).toFixed(2)}
                                    </p>
                                </div>
                            </div>
                            <div className='flex flex-row justify-center items-center self-center'>
                                <Button
                                    label={'Save Draft'}
                                    className='btn-primary min-w-[150px] mr-3 !rounded'
                                    onClickButton={() => !submitLoading && onApproveAction()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    )
}
export default ConfirmPurchaseCreate;